const takeDefaultConstants = {
  defaultCourseIds: [
    17143,
    16,
    22,
    4506,
    4317,
    3309,
    5045,
    5787,
    6898,
    7898,
    12179,
    13711,
    1,
    8,
    17003,
    5,
    17076,
    17077,
    17078,
    17079,
    17080,
    17081,
    17082
  ],
  defaultRecommendedCourseIds: [
    4506,
    4317,
    5045,
    12179,
    5787
  ],
  defaultNewCourseIds: [
    17311,
    17076,
    17077,
    17078,
    17079,
    17080,
    17081,
    17082
  ],
  defaultTopSaleCourseIds: [
    17143,
    22,
    3309,
    15839,
    5,
    5045
  ],
  defaultSpecialCourseId: {
    17329: {
      startDate: 0,
      showForAll: true,
      showNewMain: false,
      showQuiz: true
    }
  },
  defaultSpecialCourseIdsInSubscription: {
    17329: 17082
  },
  defaultSpecialCourseIdsBundle: [],
  defaultSpecialCourseIdForClub: 0,
  defaultSpecialClubId: 0,
  defaultPaywallServiceId: 343,
  defaultLinkQuiz: 'https://takeclass.io/course/tc_eng_school_up_s_quiz',
  defaultLinkBundle: 'https://anyclass.com/ru/landings/ff_school_up_general_new_bundle5',
  defaultLinkClub: 'https://anyclass.com/ru/landings/ff_school_up_general_prokrasotu_club_newsub',
  coursesForShowModalNewOffer: [17329],
  coursesForHideModalNewOffer: [17082]
}

export default takeDefaultConstants
